'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { MessageListDateDivider } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { useChatMessageUtilityClasses } from "./chatMessageClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatDateDivider');
const ChatDateDividerStyled = styled('div', {
  name: 'MuiChatMessage',
  slot: 'DateDivider',
  overridesResolver: (_, styles) => styles.dateDivider
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(1),
  fontSize: theme.typography.caption.fontSize,
  color: (theme.vars || theme).palette.text.disabled,
  userSelect: 'none'
}));
const ChatDateDividerLineStyled = styled('div', {
  name: 'MuiChatMessage',
  slot: 'DateDividerLine'
})(({
  theme
}) => ({
  flex: 1,
  height: 1,
  backgroundColor: (theme.vars || theme).palette.divider
}));
const ChatDateDividerLabelStyled = styled('div', {
  name: 'MuiChatMessage',
  slot: 'DateDividerLabel'
})(({
  theme
}) => ({
  fontSize: theme.typography.caption.fontSize,
  color: (theme.vars || theme).palette.text.disabled,
  whiteSpace: 'nowrap'
}));
const ChatDateDivider = /*#__PURE__*/React.forwardRef(function ChatDateDivider(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatDateDivider'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatMessageUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(MessageListDateDivider, _extends({
    ref: ref
  }, other, {
    slots: _extends({
      divider: slots?.divider ?? ChatDateDividerStyled,
      line: slots?.line ?? ChatDateDividerLineStyled,
      label: slots?.label ?? ChatDateDividerLabelStyled
    }, slots),
    slotProps: _extends({}, slotProps, {
      divider: _extends({
        className: clsx(classes.dateDivider, className)
      }, slotProps?.divider)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatDateDivider.displayName = "ChatDateDivider";
process.env.NODE_ENV !== "production" ? ChatDateDivider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object,
  className: PropTypes.string,
  formatDate: PropTypes.func,
  index: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.string),
  messageId: PropTypes.string.isRequired,
  slotProps: PropTypes.object,
  slots: PropTypes.object
} : void 0;
export { ChatDateDivider };